/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/**
 * This class holds constants and utility functions related to arrays
 */
export class ArrayTools {
  /**
   * Converts any object into an array.
   *
   * If the object is already an array then the object itself is returned.
   *
   * If the object is null or undefined then null is returned.
   *
   * If the object is a scalar value than an array with that value as its sole element is returned.
   *
   * @param convertible - the object that should be converted into an array.
   * @returns an array or null if convertible could not be converted into an array.
   */
  static TO_ARRAY(convertible) {
    if (Array.isArray(convertible)) {
      return convertible;
    }

    if (convertible === null || convertible === undefined) {
      return null;
    }

    return [convertible];
  }
  /**
   * Replaces properties of elements of one array with properties of elements from another array.
   *
   * @param oldElements - elements whose properties should be replaced
   * @param newElements - elements whose properties should prevail
   * @returns a new array that contains the updated elements. The length of that array equals the length of the newElements array.
   */


  static REPLACE_PROPERTIES(oldElements, newElements) {
    const merged = [];
    const newLength = newElements.length;
    const oldLength = oldElements.length;

    for (let index = 0; index < newLength; index++) {
      if (index >= oldLength) {
        merged.push(newElements[index]);
      } else {
        merged.push({ ...oldElements[index],
          ...newElements[index]
        });
      }
    }

    return merged;
  }

}
